/**
 * Generate captcha code and add it to form
 */
const handleCaptcha = (form) => {
  //   handleCaptcha() {
  return new Promise((resolve, reject) => {
    // const thisHelper = this

    // Init captcha
    grecaptcha.ready(function () {
      //6LfLt5IbAAAAAAHonAghtx3XYeWmkXvnHMx3TcFN
      grecaptcha
        .execute('6LcJdO0rAAAAAJf6u1TVzEHEki59UZpSBwQ83JD3', {
          action: 'submit',
        })
        .then(function (token) {
          // After token has been generated create/update hidden input with captcha
          let tokenCaptcha = form.querySelector(`[name='recaptcha_response']`)
          if (tokenCaptcha) {
            // If token exists, update token value
            tokenCaptcha.value = token
          } else {
            // If token does not exist create it
            tokenCaptcha = document.createElement('input')
            tokenCaptcha.setAttribute('name', 'recaptcha_response')
            tokenCaptcha.setAttribute('id', 'recaptchaResponse')
            tokenCaptcha.setAttribute('type', 'hidden')
            tokenCaptcha.setAttribute('value', token)

            // Add token to form
            form.appendChild(tokenCaptcha)
          }

          resolve('token generated')
        })
    })
  })
}

export default handleCaptcha
